"use client";
import { Container, Row, Col } from "react-bootstrap";
import Link from "next/link";
import { motion } from "framer-motion";

export default function SteeringHomepageComp(){
    const visuallyHidden = {
        border: "0",
        clip: "rect(0 0 0 0)",
        height: "1px",
        margin: "-1px",
        overflow: "hidden",
        padding: "0",
        position: "absolute",
        width: "1px",
        whiteSpace: "nowrap",
      };
      return(
    <>
     <Row style={{ margin: "0", padding: "0" }}>
        <Container
          fluid
          style={{
            backgroundColor: "black",
            backgroundImage: `url(/Images/patt.png)`,
            overflow: "hidden",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "0",
          }}
        >
     <Container style={{ minHeight: "600px" }}>
            <motion.div
              initial={{ opacity: 0, scale: 0.2 }}
              whileInView={{ opacity: 1, scale: 1 }}
              animate={{}}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <Col className="p-t-110">
                <h1 className="p-l-180 p-r-180 fs-60 font-bold colorWhite">
                  Steering the Maritime Industry Toward a Digital Future
                </h1>
                <h3
                  className="m-t-70 p-l-180 p-r-180 fs-25 colorWhite"
                  style={{ lineHeight: "1.8", letterSpacing: "3px" }}
                >
                  We're committed to playing a vital role in the maritime
                  industry's journey towards sustainability. Our software
                  solutions are designed to help you reduce fuel consumption,
                  minimize emissions, and comply with environmental regulations.
                  By optimizing routes, monitoring vessel performance, and
                  providing real-time data insights, we empower you to make
                  informed decisions that benefit both your bottom line and the
                  planet.
                </h3>
                <h5 className="m-t-70">
                  <Link className="nav-link ButtonStl" href="/about"
                   aria-describedby="desc-maritime-about"
                   >
                    
                     <span
                       id="desc-maritime-about"
                       style={visuallyHidden}
                     >
                       Orion Marine Concepts — Maritime ERP Software a
                       comprehensive, modern and user friendly suite including
                       planned maintenance system, fleet management software, ship
                       management software, Best Maritime ERP Software, crew management software, QHSSE, Document Management System, 
                       Inventory Management System, Business Intelligence, Certificate Management System, Nauserver ERP Suite, NAU Server etc."
                     </span>
                    About Us
                  </Link>
                </h5>
              </Col>
            </motion.div>
          </Container>
          </Container>
          </Row>
          </>
          )
}